import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import * as apiUtils from '.'

const url = '/vendor-devices'

export interface RemoteSensorDto {
  type: string
  uom: string
  channel?: string
  name?: string
}

export interface RemoteDeviceDto {
  externalId: string
  name: string
  serialNumber?: string
  sensorCount: number
  sensors: RemoteSensorDto[]
}

export interface VendorDeviceListDto {
  vendor: string
  missing: RemoteDeviceDto[]
  imported: RemoteDeviceDto[]
  orphanedLocal: Array<{
    manufacturerDeviceId: string | null
    loggerSerial: string
  }>
}

export interface VendorImportRequest {
  vendor: string
  imports: Array<{
    externalId: string
    /** Operator-chosen logger serial/label. Defaults to the device name. */
    loggerSerial?: string
    organizationId?: number
    projectId?: number
  }>
}

export interface VendorImportResult {
  created: Array<{ externalId: string; loggerSerial: string }>
  skipped: string[]
  failed: Array<{ externalId: string; reason: string }>
}

/** List a vendor's remote devices, diffed against our loggers for that vendor. */
export const list = (vendor: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, { params: { vendor } }, options))

/** Import the selected remote devices (create logger_ + optional site link). */
export const importDevices = (data: VendorImportRequest) =>
  apiUtils.POST(`${url}/import`, data)
